// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__2HLFE","rowsWrapper":"style_rowsWrapper__o3oe5","rowWrapper":"style_rowWrapper__l_C7R","text":"style_text__k5KVt"};